import { DnDNodeProps } from './DnDNode';

export function removeNode(tree: DnDNodeProps, node: DnDNodeProps): void {
  if (
    (tree.id !== node.id || tree.nodeType !== node.nodeType) &&
    tree.children
  ) {
    const index = tree.children.findIndex(
      item => item.id === node.id && item.nodeType === node.nodeType
    );
    if (index !== -1) {
      tree.children.splice(index, 1);
    } else {
      for (let i = 0; i < tree.children.length; i++) {
        removeNode(tree.children[i], node);
      }
    }
  }
}

export function addChildNode(
  tree: DnDNodeProps,
  node: DnDNodeProps,
  to: DnDNodeProps
): void {
  if (tree.id === to.id && tree.nodeType === to.nodeType) {
    tree.children.push(node);
  } else if (tree.children) {
    for (let i = 0; i < tree.children.length; i++) {
      addChildNode(tree.children[i], node, to);
    }
  }
}

export function replaceNode(
  tree: DnDNodeProps,
  node: DnDNodeProps,
  to: DnDNodeProps,
  position = 'next' as 'next' | 'prev'
): void {
  if (!tree.children) return;

  const index = tree.children.findIndex(
    child => child.id === to.id && child.nodeType === to.nodeType
  );

  if (index !== -1) {
    tree.children.splice(index + (position === 'next' ? 1 : 0), 0, node);
    return;
  }

  for (let i = 0; i < tree.children.length; i++) {
    replaceNode(tree.children[i], node, to, position);
  }
}
